export default {
  BusinessStockEntryResult: {
    header: {
      queryCode: 'Order No.',
      queryCodeText: 'Inbound notice Order No. / Customer Order No. / Internal Order No. / pre-Order No.',
      status: 'Inbound status',
      receivingLogicWarehouseCode: 'Inbound logic warehouse',
      receivingLogicWarehouseCodeText: 'Please enter the logic warehouse code',
    },

    table: {
      code: 'Inbound result Order No.',
      warehouseWarrantCode: 'Inbound notice Order No.',
      inputTypeMeaning: 'Inbound type',
      statusMeaning: 'Inbound status',
      alreadyQty: 'Quantity received',
      receivingLogicWarehouseCode: 'Inbound logic warehouse code',
      receivingLogicWarehouseName: 'Inbound logic warehouse name',
      storeName: 'Store',
      channelTypeCodeMeaning: 'Sales Channel',
    }
  },
  BusinessStockEntryResultView: {
    title: 'Account Information',
    code: 'Inbound result Order No.',
    receivingLogicWarehouseCode: 'Inbound logic warehouse code',
    receivingLogicWarehouseName: 'Inbound logic warehouse name',
    inputTypeMeaning: 'Inbound Type',
    statusMeaning: 'Inbound Status',
    returnsName: 'Returner',
    returnsMobile: 'Returner Phone Number',
    cptAddress: 'Returner Address',
    associated: 'Related Documents',
    warehouseWarrantCode: 'Inbound notice Order No.',
    orderCode: 'CSG Order No.',
    platformOrderCode: 'Customer Order No.',
    productInformation: 'Product Information',
    alreadyTotalQty: 'Quantity Received',
    noDataText: 'None',

    table: {
      spuCode: 'Product Code',
      skuName: 'SKU Name',
      skuCode: 'SKU',
      alreadyInputQty: 'Quantity Received',
      spuName: 'Product Name',
    }
  }
};
